import { IconButton, Stack } from "@mui/material";
import DeleteIcon from "src/assets/svg-icons/aggregators/delete.svg";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { useDeleteAggCostAndFeesMutation } from "src/api/aggreagators";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { useTranslation } from "react-i18next";
import { specificBranchHasPermission } from "src/utils";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const TableActions = ({
  rowId,
  rowRef,
  refetch,
  branchId,
}: {
  rowId: number;
  rowRef: string;
  refetch: Function;
  branchId: number;
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const { t } = useTranslation("aggregators");

  // Permissions
  const deletePermission = specificBranchHasPermission(
    "delete_aggregator_cost_and_fee",
    branchId
  );

  const { mutate, isPending, status, error } =
    useDeleteAggCostAndFeesMutation();

  const navigateToEditPage = () => {
    navigate(`/aggregators/edit-agg-fees/${rowId}`);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    mutate(rowId);
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleClose();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: t("deletedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || t("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack
      direction={"row"}
      spacing={"12px"}
      width={"100%"}
      justifyContent={"center"}
    >
      <IconButton onClick={navigateToEditPage}>
        <VisibilityOutlinedIcon fontSize="small" />
      </IconButton>

      {deletePermission && (
        <IconButton onClick={handleClickOpen}>
          <img src={DeleteIcon} alt="" />
        </IconButton>
      )}

      {/* confirm delete popup */}
      <ConfirmPopup
        open={open}
        item={rowRef}
        handleClose={handleClose}
        handleConfirm={handleDelete}
        isPending={isPending}
      />
    </Stack>
  );
};
export default TableActions;
